export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
  region: import.meta.env.VITE_REGION || 'us-east-1',
  /** Base address of the Pricing app (no trailing slash needed). Empty when not configured; the "Add it in Pricing" link then never appears. */
  pricingUrl: import.meta.env.VITE_PRICING_URL || '',
};
